import { Injectable } from '@angular/core';
import { StreamApi } from './api/stream-api';
import { StreamDto } from './model';

@Injectable({
  providedIn: 'root'
})
export class StreamService {

  constructor(private streamApi: StreamApi) { }

  public async getStreamData() {
    return new Promise<StreamDto>(resolve => {
      this.streamApi.getStreamData()
        .subscribe(streamData => resolve(streamData));
    });
  }

  public async updateStreamData({ streamUrl, available }) {
    const streamData: StreamDto = {
      url: streamUrl,
      available
    };

    return new Promise<StreamDto>(resolve => {
      this.streamApi.updateStreamData(streamData)
        .subscribe(updatedStreamData => resolve(updatedStreamData));
    });
  }
}
